import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import BannerSlider from './components/BannerSlider/BannerSlider';
import OnlineRepairsSlider from './components/OnlineRepairs/OnlineRepairsSlider';
import CategoryCards from './components/CategoryCards/CategoryCards';
import HighlightsSlider from './components/HighlightsSlider/HighlightsSlider';
import SatisfiedCustomersSlider from './components/SatisfiedCustomersSlider/SatisfiedCustomersSlider';
import ImagesPanorama from './components/ImagesPanorama/ImagesPanorama';
import FAQSection from './components/FAQSection/FAQSection';
import RepairRevolution from './components/RepairRevolution/RepairRevolution';
// import WhyRepairRebels from './components/WhyRepairRebels/WhyRepairRebels';
import AwardsSlider from './components/Awards/AwardsSlider';

export default function Homepage() {
  const { t } = useTranslation();
  return (
    <div>
      <Helmet>
        <title>{t('landing-title')}</title>
        <meta name="description" content={t('landing-description')} />
      </Helmet>
      <BannerSlider/>
      <OnlineRepairsSlider/>
      <CategoryCards />
      <HighlightsSlider/>
      <SatisfiedCustomersSlider/>
      <ImagesPanorama/>
      <FAQSection/>
      <AwardsSlider/>
      <RepairRevolution/>
      {/* <WhyRepairRebels /> */}
    </div>
  );
}
